import React, { useEffect, Fragment, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import Breadcrumbs from 'CommonElements/Breadcrumbs';
import AdminForm from 'Component/DashboardQeza/Admin/Form';
import { getAllAdmin } from 'Services/Features/Admin/Utils/adminUtils';
import { setFormData, resetFormData } from 'Services/Features/Admin/adminSlice';

const AdminAdd = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const filters = useSelector(state => state.admin.filters)
    const currentAdmin = useSelector((state) => state.admin.currentAdmin);
    const [refetch, setRefetch] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);

        if (id && !currentAdmin?.id) {
            // Buat filter untuk ambil data berdasarkan ID
            const newFilters = {
                ...filters,
                "filter[id]": id,
                page: 1,
            };

            // Fetch data dari API pakai ID
            dispatch(getAllAdmin(newFilters)).then((response) => {
                if (response.payload && response.payload.data?.length > 0) {
                    const item = response.payload.data[0]; // Ambil item pertama (kalau ada)
                    dispatch(setFormData({
                        id: item.id,
                        name: item.name,
                        email: item.email,
                        branch_id: item.branch_id,
                        is_super_admin: item.is_super_admin,
                        is_admin: item.is_admin,
                        is_cs: item.is_cs,
                    }));
                }
            });
        } else if (currentAdmin?.id) {
            // Kalau nggak ada ID, tapi ada data di state, pakai yang ada
            dispatch(setFormData({
                ...currentAdmin,
            }));
        } else {
            // Kalau nggak ada ID & data di state, reset form
            dispatch(resetFormData());
        }
    }, [id, refetch]);



    return (
        <Fragment>
            <Breadcrumbs parent="Admin" title={id ? 'Edit Akun Admin' : 'Tambah Akun Admin'} />
            <AdminForm label={id ? "" : "Akun Admin Baru"} setRefetch={setRefetch} />
        </Fragment>
    );
};
export default AdminAdd;